import { useState } from "react";

/**
 * コード例。折り返さず、そのまま貼れる形で出す。
 *
 * ★ **1 つだけ置く。** 使い方（サポートページ）とデプロイ UI の両方で
 * 使うので、書き分けると片方だけ直すことになる。
 */
export function Code({ children }: { children: string }): React.JSX.Element {
  const [copied, setCopied] = useState(false);
  return (
    <div className="code-block">
      <button
        type="button"
        className="code-copy"
        onClick={() => {
          void navigator.clipboard
            ?.writeText(children)
            .then(() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            })
            // クリップボードが使えない環境でも、選んで手でコピーできる。
            .catch(() => undefined);
        }}
      >
        {copied ? "コピーしました" : "コピー"}
      </button>
      <pre>{children}</pre>
    </div>
  );
}
